import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class InternalEventsManagerService {

  constructor() { }

  reloadUserData = new EventEmitter<string>();
  teamActiveMoovs_dataLoaded = new EventEmitter<string>();
  detailsViewActivated = new EventEmitter<string>();
  userLoggedIn = new EventEmitter();
  userLoggedOut = new EventEmitter();
  auth0LoginSuccess = new EventEmitter();
  pulseCheckCompleted = new EventEmitter();
}
